<!--
 * @Author: your name
 * @Date: 2020-11-17 11:15:55
 * @LastEditTime: 2021-03-22 15:00:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\association.vue
-->
<template>
  <div class="association type-page">
      <h1>在线课堂 <br/>
      <span>Online classroom</span>
      <router-link tag="span" class="more" to="/learning">More+</router-link>
      </h1>
      <ul class="clearfix">
          <li
           v-for="item of association"
           :key="item.id"
           @click="JumpDetail(item.id)"
          >
            <div>
                <img :src="item.image" alt="">
            </div>    
              <h2 class="ellipsis">{{item.title}}</h2>
              <p class="ellipsis2" v-html="item.desc">{{item.desc}}</p>
              <span :style="{color: (item.price == '0.00' ? 'red' : '')}">{{item.price == '0.00' ? '免费' : `￥${item.price}`}}</span>
          </li>
         
      </ul>
  </div>
</template>

<script>
export default {
    props:['association'],
    methods: {
        JumpDetail(id){
            this.$router.push({
                path: '/courseDetail',
                 query:{
                     courseId: id
                 }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.association {
    h1 {
        font-size: 18px;
        font-weight: bold;
        color: #2B2F37;
        margin: 24px 0;
        span {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
        }
        .more {
            float: right;
            color: #4165ff;
            margin-top: -10px;
            cursor: pointer;
        }
    }
     ul {
         margin-bottom: 76px;
         li {
             width: 18.7%;
             margin-right: 15px;
             float: left;
             padding-bottom: 24px;
             box-shadow: 2px 1px 8px rgba(65, 101, 255, 0.22);
             overflow: hidden;
             img {
                 width: 100%;
                 height: 168px;
                 transition:all .8s ease-out;
             }
             h2 {
                font-size: 16px;
                font-weight: bold;
                margin: 24px 0 14px;
                padding: 0 16px;
                line-height: 25px;
             }
             p {
                color: #999999;
                line-height: 19px;
                margin-bottom: 24px;
                padding: 0 16px;
                min-height: 38px;
             }
             span {
                 padding: 0 16px;
                color: #4165FF;
                line-height: 20px;
             }
             &:hover {
                 img {
                     transform: scale(1.05);
                 }
                 box-shadow: 0px 4px 8px rgba(65, 101, 255, 0.22);
             }
         }
     }
}
</style>



// WEBPACK FOOTER //
// src/components/index/association.vue